// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { artelaTestnet as _artelaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the artelaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11822
 * Chain Name: Artela Testnet
 * Default Block Explorer: https://betanet-scan.artela.network
 * Default RPC URL: https://betanet-rpc1.artela.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { artelaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: artelaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const artelaTestnet = createCommon({
	..._artelaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
